import Vue from "vue"
import App from "./App.vue"
import store from "@/core/store"
import router from "@/core/services/router.service"
import '@/core/plugins/plugin-service-provider'
import '@/core/directives/directive-service-provider'
import '@/core/mixins/mixin-service-provider'
import '@/core/filters/filter-service-provider'


Vue.config.productionTip = false;

window.eventBus = new Vue({})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");